import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './i18n' // i18n must be imported before App (Story 11.1)
import './index.css'
import App from './App.tsx'
import { initSentry } from './config/sentry'

// Initialize Sentry error tracking before rendering the app
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
